module.exports = __webpack_public_path__ + "img/help-circle-outline.7afa7049.svg";